import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import request from '../utils/request';

// 同意/拒绝后展示的结果页
function ResultCard({ type, nickname, onBack }) {
  const isAgreed = type === 'agreed';
  return (
    <div style={{ textAlign: 'center', padding: '40px 16px' }}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>
        {isAgreed ? '🎉' : '👋'}
      </div>
      <h2 style={{ color: isAgreed ? '#4CAF50' : '#999', marginBottom: 12 }}>
        {isAgreed ? '同意成功！' : '已婉拒'}
      </h2>
      {isAgreed ? (
        <p style={{ color: '#666', lineHeight: 1.6, marginBottom: 24 }}>
          你已同意与 <strong>{nickname}</strong> 认识<br />
          对方已通过服务通知收到你的微信号<br />
          <span style={{ fontSize: 13, color: '#999' }}>请留意对方的好友申请，备注"AI相亲"</span>
        </p>
      ) : (
        <p style={{ color: '#999', lineHeight: 1.6, marginBottom: 24 }}>
          你已婉拒了 <strong>{nickname}</strong> 的牵线请求<br />
          <span style={{ fontSize: 13 }}>对方已收到通知</span>
        </p>
      )}
      <button className="btn btn-primary" onClick={onBack} style={{ minWidth: 120 }}>
        返回消息
      </button>
    </div>
  );
}

function Match() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [matchData, setMatchData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [result, setResult] = useState(null); // 'agreed' | 'rejected'
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectMessage, setRejectMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchMatchDetail();
  }, [id]);

  const fetchMatchDetail = async () => {
    try {
      const res = await request({ url: `/api/match/${id}`, method: 'GET' });
      setMatchData(res.data);
    } catch (err) {
      console.error('获取牵线详情失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleAgree = async () => {
    if (!window.confirm(`确定同意与 ${matchData.nickname} 认识吗？\n同意后，对方将通过服务消息收到你的微信号。`)) return;
    setActionLoading(true);
    try {
      await request({ url: `/api/match/${id}/agree`, method: 'POST' });
      setResult('agreed');
    } catch (err) {
      const msg = err.response?.data?.error || '操作失败，请稍后重试';
      alert('❌ ' + msg);
    } finally {
      setActionLoading(false);
    }
  };

  const handleReject = async (msg) => {
    const m = (msg || '').trim();
    if (m && m.length > 50) {
      alert('留言不能超过50个字');
      return;
    }
    setActionLoading(true);
    try {
      await request({ url: `/api/match/${id}/reject`, method: 'POST', data: { message: m || undefined } });
      setShowRejectModal(false);
      setRejectMessage('');
      setResult('rejected');
    } catch (err) {
      alert('❌ 操作失败，请稍后重试');
    } finally {
      setActionLoading(false);
    }
  };

  // 加载中
  if (loading) {
    return (
      <div className="container" style={{ textAlign: 'center', paddingTop: 60 }}>
        <div className="loading">加载中...</div>
      </div>
    );
  }

  // 请求不存在或已处理
  if (!matchData) {
    return (
      <div className="container">
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📭</div>
          <p style={{ color: '#999', marginBottom: 20 }}>请求不存在或已处理</p>
          <button className="btn btn-primary" onClick={() => navigate('/messages')}>
            返回消息中心
          </button>
        </div>
      </div>
    );
  }

  // 操作完成后展示结果页
  if (result) {
    return (
      <div className="container">
        <div className="card">
          <ResultCard
            type={result}
            nickname={matchData.nickname}
            onBack={() => navigate('/messages')}
          />
        </div>
      </div>
    );
  }

  const { nickname, avatar, age, city, job, intro, request_message } = matchData;

  return (
    <div className="container">
      {/* 顶部返回 */}
      <button
        className="btn btn-secondary"
        onClick={() => navigate('/messages')}
        style={{ marginBottom: 16 }}
      >
        ← 返回消息
      </button>

      {/* 标题 */}
      <div style={{ textAlign: 'center', marginBottom: 16 }}>
        <h2 style={{ color: '#ff6b6b', fontSize: 18 }}>✨ 有人想认识你</h2>
      </div>

      {/* 用户资料卡片 */}
      <div className="card" style={{ textAlign: 'center', paddingTop: 28 }}>
        <img
          src={avatar || 'https://via.placeholder.com/80?text=头像'}
          alt={nickname}
          style={{
            width: 80, height: 80, borderRadius: '50%',
            objectFit: 'cover', border: '3px solid #ff6b6b',
            marginBottom: 12
          }}
        />
        <h3 style={{ fontSize: 20, marginBottom: 10 }}>{nickname}</h3>
        <div className="tags" style={{ justifyContent: 'center', marginBottom: 4 }}>
          {age && <span className="tag">{age}岁</span>}
          {city && <span className="tag">📍 {city}</span>}
          {job && <span className="tag">💼 {job}</span>}
        </div>
      </div>

      {/* 对方留言（如有） */}
      {request_message && (
        <div className="card" style={{ borderLeft: '4px solid #ff6b6b' }}>
          <h3 style={{ fontSize: 15, color: '#ff6b6b', marginBottom: 8 }}>💌 TA 的留言</h3>
          <p style={{ color: '#666', lineHeight: 1.7, fontSize: 14 }}>{request_message}</p>
        </div>
      )}

      {/* 自我介绍 */}
      <div className="card">
        <h3 style={{ fontSize: 15, color: '#333', marginBottom: 8 }}>💬 自我介绍</h3>
        <p style={{ color: '#666', lineHeight: 1.7, fontSize: 14 }}>
          {intro || '这个人很神秘，什么都没留下～'}
        </p>
      </div>

      {/* 操作按钮 */}
      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        <button
          className="btn btn-success"
          onClick={handleAgree}
          disabled={actionLoading}
          style={{ flex: 1, fontSize: 16, padding: '14px 0' }}
        >
          {actionLoading ? '处理中...' : '✅ 同意认识'}
        </button>
        <button
          className="btn btn-danger"
          onClick={() => { setRejectMessage(''); setShowRejectModal(true); }}
          disabled={actionLoading}
          style={{ flex: 1, fontSize: 16, padding: '14px 0' }}
        >
          {actionLoading ? '处理中...' : '❌ 婉拒'}
        </button>
      </div>

      <p style={{ textAlign: 'center', color: '#bbb', marginTop: 14, fontSize: 13 }}>
        同意后，对方将通过服务消息收到你的微信号
      </p>

      {/* 拒绝留言弹窗 */}
      {showRejectModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000, padding: 16
        }} onClick={() => !actionLoading && setShowRejectModal(false)}>
          <div className="card" style={{ maxWidth: 400, width: '100%' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: 12 }}>婉拒 {matchData.nickname} 的牵线</h3>
            <p style={{ color: '#666', fontSize: 14, marginBottom: 12 }}>留言（可选，最多50字）</p>
            <textarea
              value={rejectMessage}
              onChange={e => setRejectMessage(e.target.value.slice(0, 50))}
              placeholder="想对 TA 说点什么..."
              maxLength={50}
              rows={3}
              style={{
                width: '100%', padding: 10, borderRadius: 8, marginBottom: 12,
                boxSizing: 'border-box', resize: 'vertical',
                border: '1px solid #ddd', fontSize: 14, lineHeight: 1.5,
                outline: 'none', fontFamily: 'inherit'
              }}
              onFocus={e => e.target.style.borderColor = '#ff6b6b'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
            <p style={{ color: '#999', fontSize: 12, marginBottom: 16 }}>{rejectMessage.length}/50</p>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => setShowRejectModal(false)} disabled={!!actionLoading}>
                取消
              </button>
              <button className="btn btn-danger" style={{ flex: 1 }} onClick={() => handleReject(rejectMessage)} disabled={!!actionLoading}>
                {actionLoading ? '处理中...' : '确认婉拒'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Match;